function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19 0H5C2.23858 0 0 2.23858 0 5V19C0 21.7614 2.23858 24 5 24H19C21.7614 24 24 21.7614 24 19V5C24 2.23858 21.7614 0 19 0Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0541 20.4039C11.9162 20.4056 11.7818 20.369 11.6614 20.3027C10.6368 19.7092 3.04759 14.9511 2.75959 14.8062C2.54141 14.705 2.39304 14.4955 2.36686 14.2564V7.58004C2.36162 7.33044 2.48381 7.09655 2.69327 6.9604L2.74912 6.92898C3.48395 6.47342 5.94156 4.97407 6.33079 4.75763C6.41981 4.70527 6.52105 4.6756 6.62578 4.6756C6.72352 4.67734 6.81777 4.70178 6.90505 4.74542C6.90505 4.74542 10.3453 6.98658 10.8707 7.18731C11.239 7.35662 11.6422 7.44215 12.0489 7.43516C12.5097 7.44564 12.9635 7.33393 13.3685 7.114C13.8834 6.84345 17.1701 4.75763 17.205 4.75763C17.287 4.70702 17.383 4.68258 17.479 4.68258C17.582 4.68258 17.685 4.71225 17.774 4.76462C18.2208 5.01247 21.2684 6.87662 21.3976 6.95865C21.6123 7.08782 21.7414 7.32171 21.7397 7.57131V14.2459C21.7152 14.4851 21.5669 14.6945 21.3469 14.7958C21.0607 14.9528 13.4941 19.711 12.4504 20.2922C12.3264 20.3638 12.192 20.4022 12.0541 20.4039Z",
  fill: "url(#paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.014 20.4039H12.0524C12.1903 20.4057 12.3247 20.369 12.4451 20.3009C13.4697 19.7075 21.0555 14.9494 21.3417 14.8045C21.5617 14.7033 21.71 14.4956 21.7345 14.2547V7.58006C21.7362 7.46661 21.71 7.3549 21.6594 7.25366L12.0123 12.5511V20.4039",
  fill: "url(#paint2_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9815 20.3098H11.9418C11.8054 20.3116 11.6724 20.2753 11.5532 20.2097C10.5396 19.6226 3.03465 14.9151 2.75144 14.7718C2.53386 14.6716 2.38707 14.4662 2.3629 14.2278V7.6226C2.36117 7.51036 2.38707 7.39984 2.43715 7.29968L11.9815 12.5407V20.3098",
  fill: "url(#paint3_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M7.33331 9.76331H8.21328V13.9948H9.72798V14.8315H7.33812L7.33331 9.76331Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7668 11.0327C12.2333 11.0279 12.6757 11.2395 12.9594 11.605V11.1049H13.7816V14.8363H12.9594V14.3362C12.6709 14.7017 12.2333 14.9181 11.7668 14.9084C10.7426 14.9084 9.96844 14.0333 9.96844 12.9658C9.96844 11.9079 10.7426 11.0327 11.7668 11.0327ZM11.9159 11.7829C11.2523 11.7829 10.8099 12.307 10.8099 12.9754C10.8099 13.6438 11.2571 14.1679 11.9159 14.1679C12.5747 14.1679 13.0219 13.6438 13.0219 12.9754C13.0219 12.307 12.5795 11.7829 11.9159 11.7829Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4211 14.192L16.3782 11.855H14.45V11.1097H17.4361V11.7685L15.4886 14.0958H17.4794V14.8411H14.4211V14.192",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 11.7592,
  y1: -20.5138,
  x2: 12.0693,
  y2: 21.3464,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.3379,
  stopColor: "#5B8BEB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7794,
  stopColor: "#2742A2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#112283"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 2.41556,
  y1: 12.5926,
  x2: 89.5563,
  y2: 11.9176,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 1e-7,
  stopColor: "#FFB900"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3376,
  stopColor: "#F38000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5673,
  stopColor: "#F83C72"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#FC1CBE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#FE08ED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF00FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 7.80886,
  y1: 18.8743,
  x2: 96.6525,
  y2: -30.3177,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EE0A3F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EE0A3F",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 9.86045,
  y1: 15.6779,
  x2: 52.3353,
  y2: -18.5379,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ED6600"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F98200"
})));

function SvgLazada(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLazada);
export default __webpack_public_path__ + "static/media/Lazada.8e80c7bb.svg";
export { ForwardRef as ReactComponent };